import React, { PureComponent } from 'react';
import ErrorBoundary from '../utils/api/errorBoundary';
import HyperlinkTemplate from './hyperlinkTemplate';

interface IBracketTemplateProps {
    source: any;
    element: string;
}

export class BracketTemplate extends PureComponent<IBracketTemplateProps, any> {
    constructor(props: IBracketTemplateProps) {
        super(props);
    }

    public render() {
        const { source, element } = this.props;

        return (
            <div className="x-bbry-bracket">
                <span className="x-rsch-run">&nbsp;</span>
                <div>{element}</div>
                <span className="x-rsch-run">&nbsp;-&nbsp;</span>
                <ErrorBoundary><HyperlinkTemplate source={source} /></ErrorBoundary>
                <span className="x-rsch-run">&nbsp;</span>
            </div>
        );
    }
}

export default BracketTemplate;
